module.exports = __webpack_public_path__ + "img/cta-dosing-bg-mobile.ead6142a.png";